/*
 Copyright (c), CKSource Holding sp. z o.o. All rights reserved.
 */

import Message, { IMessage, IMessageConstructor } from '../../../message';

export interface IPackageDataMessageConstructor extends IMessageConstructor {
	new( ...args: unknown[] ): PackageDataMessage;

	readonly TYPE: number;

	create( data: unknown, data1: unknown ): PackageDataMessage;
}

export interface IPackageDataMessage extends IMessage {
	readonly data?: unknown;
	readonly data1?: unknown;
}

export default abstract class PackageDataMessage extends Message {
	public readonly data: unknown;

	public readonly data1: unknown;

	public declare [ 'constructor' ]: IPackageDataMessageConstructor;

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	public static create( data: unknown, data1: unknown ): PackageDataMessage {
		throw new TypeError( 'Must be implemented in a child class!' );
	}
}
